// Vendors
import styled from 'styled-components';

const SessionExpireTimeoutComponentStyled = styled.section`
  margin-top: ${({ theme }) => theme.spacing_550};
`;
SessionExpireTimeoutComponentStyled.displayName = 'SessionExpireTimeoutComponentStyled';

export { SessionExpireTimeoutComponentStyled };
